<script setup>
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { t } from "@/controllerLK/AvalLocalization";
import BookmarkIcon from "@/components/Icons/BookmarkIcon.vue";
import {defineEmits} from "vue";

const emit = defineEmits(["update:is-toolbar-active"]);

const rubricsStore = useRubricsStore();
const store = useNewsFeedStore();

async function toggleFavoriteVisible() {
  store.isMarked = false;
  store.favoriteVisible = !store.favoriteVisible;

  store.clearNewsFeed();
  await store.getNews();
  emit("update:is-toolbar-active", false);
}

</script>

<template>
  <AvalButtonFixedPrimary
    v-if="rubricsStore.chosenRubrics.length >= 0 && rubricsStore.isCurrentRubricFixed()"
    :is-active="store.favoriteVisible"
    size="large"
    @click="toggleFavoriteVisible"
  >
    <template #icon-left>
      <BookmarkIcon class="icon" />
    </template>
    {{ t('news_page_body_roof.button.favorite') }}
  </AvalButtonFixedPrimary>
</template>

<style scoped>
.icon {
  margin-bottom: 3px;
}
</style>
